import type { EventRowLines } from "web_myplann/Shared/Types/EventRowLines";
import { EventRowVariant } from "web_myplann/Shared/Types/EventRowVariant";
import { joinTruthy } from "web_myplann/Shared/Utils/textFormatters";
import { CIRCLE_SIGN, DOT_SEPARATOR } from "web_myplann/Utils/constants";

type TaskRowInput = {
	variant: EventRowVariant;
	taskLabel: string;
	title: string;
	dueDate: string;
	person?: string;
};

export const mapTaskRowLines = ({
	variant,
	taskLabel,
	title,
	dueDate,
	person,
}: TaskRowInput): EventRowLines => {
	const details = person ? [person] : [];

	if (variant === EventRowVariant.Preview) {
		return {
			overline: dueDate || undefined,
			title: `${taskLabel} ${CIRCLE_SIGN} ${title}`,
			variant,
			details,
		};
	}

	return {
		overline: joinTruthy([taskLabel, dueDate], DOT_SEPARATOR),
		title,
		variant,
		details,
	};
};
